import React, { HTMLAttributes } from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IModalButtonFooterProps extends HTMLAttributes<HTMLDivElement> {
  buttons?: React.ReactNode;
  custom?: boolean;
  vertical?: boolean;
  centeredButtons?: boolean;
}

export default function ModalButtonFooter({
  buttons,
  children,
  custom,
  vertical,
  className,
  centeredButtons = true,
  ...otherProps
}: IModalButtonFooterProps): React.ReactElement {
  const bem = bemBlock('modal-button-footer');

  return (
    <div
      className={bem(
        null,
        [{ vertical }, { custom }, { empty: !buttons && !children }, { 'centered-buttons': centeredButtons }],
        className
      )}
      {...otherProps}
    >
      {buttons}
      {children}
    </div>
  );
}
